/**
 * Converts a field value to an array of participant IDs.
 * @param {string} idField - A single participant ID or an array of participant IDs.
 * @returns {string[]} An array of participant IDs.
 */
export const toParticipantsArray = (idField) => {
  if (Array.isArray(idField)) return idField;
  return idField ? [idField] : [];
};

/**
 * Converts a user object to a participant option for selection components.
 * @param {Object} user - The user object containing participant details.
 * @param {string} user._id - The unique identifier of the user.
 * @param {string} user.first_name - The first name of the user.
 * @param {string} user.last_name - The last name of the user.
 * @returns {Object} An object with 'value' and 'label' properties for selection components.
 */
export const toParticipantOption = (user) => ({
  value: user?._id,
  label: `${user?.last_name || ''} ${user?.first_name || ''}`.trim()
});
